// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-item {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  border-radius: 12px;
  border: solid 1px var(--accent-color);
  transition: border 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.card-item.selected {
  border: 1px solid #fff;
}
.card-item .default-img {
  padding: 5px;
  object-fit: contain !important;
  background-color: #fff;
}
.card-item .image-block {
  width: 70%;
  position: relative;
  margin-top: 20px;
  margin-bottom: 8px;
}
.card-item .image-block ion-img {
  width: 100%;
  height: 100%;
  aspect-ratio: 512/371;
  object-fit: contain;
}
.card-item .image-block .plus {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 32px;
  width: 32px;
}
.card-item .info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.card-item .info-block .name {
  padding: 0 5px;
  margin: 0;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-item .info-block .deposit_text {
  font-size: 9px;
  font-family: AppFont, sans-serif;
  margin: 0;
  margin-top: 20px;
  text-align: center;
}

.price {
  font-family: AppFontMedium, sans-serif;
  text-align: center;
  font-size: 13px;
  z-index: 1;
  position: absolute;
  top: 10px;
  right: 10px;
}

.quantity-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.quantity-selector .quantity {
  font-size: 20px;
  font-family: AppFont;
}
.quantity-selector .quantity-btn {
  width: 30px;
  height: 30px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}

.selected_item_icon {
  position: absolute;
  top: 8px;
  left: 8px;
  transition: opacity 0.3s ease-in-out;
  justify-content: center;
  display: flex;
  align-items: center;
  background: var(--accent-color);
  border-radius: 4px;
  width: -moz-fit-content;
  margin: 0 auto;
  height: 20px;
  width: 20px;
}

.footer-section {
  padding: 5px 0px 10px;
  min-width: 65%;
}

.add-icon {
  width: 22px;
  height: 22px;
  min-height: 22px;
  border-radius: 4px;
  background: #CACACA;
  padding: 0;
}
.add-icon ion-icon {
  margin: 0 auto !important;
  height: 14px;
  width: 14px;
}

.add-button {
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.add-button ion-button {
  min-height: 34px;
  min-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recommendation-article/recommendation-article.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EAEA,mBAAA;EACA,qCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAHF;AAKE;EACE,sBAAA;AAHJ;AAME;EACE,YAAA;EACA,8BAAA;EACA,sBAAA;AAJJ;AAOE;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AAWI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AATN;AAYI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAVN;AAcE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAZJ;AAcI;EACE,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAbN;AAgBI;EACE,cAAA;EACA,gCAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAdN;;AAmBA;EACE,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAhBF;;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EAOA,YAAA;AAvBF;AAkBE;EACE,eAAA;EACA,eAAA;AAhBJ;AAqBE;EACE,eAAA;EACA,oBAAA;AAnBJ;AAsBE;EACE,WAAA;EACA,YAAA;AApBJ;AAsBI;EACE,YAAA;AApBN;;AAyBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AAtBF;;AAyBA;EACE,qBAAA;EACA,cAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAtBF;AAwBE;EACE,yBAAA;EACA,YAAA;EACA,WAAA;AAtBJ;;AA0BA;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAvBF;AAwBE;EACE,gBAAA;EACA,eAAA;AAtBJ","sourcesContent":["@import '../../../theme/mixins';\n\n.card-item {\n  position: relative;\n  margin: 0 auto;\n  flex-grow: 1;\n  min-height: 100%;\n  word-break: break-word;\n\n  border-radius: 12px;\n  border: solid 1px var(--accent-color);\n\n  transition: border 200ms linear;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n\n  &.selected {\n    border: 1px solid #fff;\n  }\n\n  .default-img {\n    padding: 5px;\n    object-fit: contain !important;\n    background-color: #fff;\n  }\n\n  .image-block {\n    width: 70%;\n    position: relative;\n    margin-top: 20px;\n    margin-bottom: 8px;\n\n    // &:has(.default_img) {\n    // \tbackground-color: var(--ion-color-primary);\n    // }\n\n    ion-img {\n      width: 100%;\n      height: 100%;\n      aspect-ratio: 512 / 371;\n      object-fit: contain;\n    }\n\n    .plus {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      height: 32px;\n      width: 32px;\n    }\n  }\n\n  .info-block {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    flex-grow: 1;\n\n    .name {\n      padding: 0 5px;\n      margin: 0;\n      display: flex;\n      align-items: center;\n      text-transform: uppercase;\n      word-break: break-word;\n\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .deposit_text {\n      font-size: 9px;\n      font-family: AppFont, sans-serif;\n      margin: 0;\n      margin-top: 20px;\n      text-align: center;\n    }\n  }\n}\n\n.price {\n  font-family: AppFontMedium, sans-serif;\n  text-align: center;\n  font-size: 13px;\n  z-index: 1;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n\n.quantity-selector {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  ion-icon {\n    margin: 0px 6px;\n    cursor: pointer;\n  }\n\n  z-index: 999;\n\n  .quantity {\n    font-size: 20px;\n    font-family: AppFont;\n  }\n\n  .quantity-btn {\n    width: 30px;\n    height: 30px;\n\n    &.add-opacity {\n      opacity: 0.5;\n    }\n  }\n}\n\n.selected_item_icon {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  transition: opacity 0.3s ease-in-out;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  background: var(--accent-color);\n  border-radius: 4px;\n  width: -moz-fit-content;\n  margin: 0 auto;\n  height: 20px;\n  width: 20px;\n}\n\n.footer-section {\n  padding: 5px 0px 10px;\n  min-width: 65%;\n}\n\n.add-icon {\n  width: 22px;\n  height: 22px;\n  min-height: 22px;\n  border-radius: 4px;\n  background: #CACACA;\n  padding: 0;\n\n  ion-icon {\n    margin: 0 auto!important;\n    height: 14px;\n    width: 14px;\n  }\n}\n\n.add-button {\n  width: 100%;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  ion-button {\n    min-height: 34px;\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
